"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_TRAININGS = void 0;
var client_1 = require("@apollo/client");
var TrainingFragment_1 = require("../fragments/TrainingFragment");
exports.GET_ALL_TRAININGS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query Trainings {\n    trainings {\n      ...Training\n    }\n  }\n  ", "\n"], ["\n  query Trainings {\n    trainings {\n      ...Training\n    }\n  }\n  ", "\n"])), TrainingFragment_1.TRAINING_FRAGMENT);
var templateObject_1;
